import { jsx as t } from "react/jsx-runtime";
import { forwardRef as m } from "react";
import { MaskInput as n } from "../../MaskInput/MaskInput.mjs";
import "../../MaskInput/MaskBase.mjs";
import { CreditCardIcon as p } from "../../../icons/componentIcons.mjs";
const a = m((r, o) => {
  const { ...i } = r;
  return /* @__PURE__ */ t(
    n,
    {
      ref: o,
      format: "####",
      mask: "",
      ...i,
      inputRightElement: /* @__PURE__ */ t(p, { className: "ccinput-right-icon", variant: "light" })
    }
  );
});
a.displayName = "CCCvcInput";
export {
  a as CCCvcInput
};
